'use strict';

exports.__esModule = true;

exports.default = function (string) {
  return string.replace(/["']/g, '');
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/postcss-minify-selectors/dist/lib/unquote.js
// module id = 1628
// module chunks = 0